var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"lucide lucide-message-circle w-6 h-6 text-purple-600",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"#000000","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M7.9 20A9 9 0 1 0 4 16.1L2 22Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }